import localforage from "localforage";
import { jwtDecode } from "jwt-decode";

import { DataCacheKey } from "./utils/constants";
import { CustomerDataEntry, FilterData } from "./utils/interfaces";

export const TOKEN = {
  get: async () => {
    const loginData = sessionStorage.getItem(DataCacheKey.TOKEN_KEY);
    if (!loginData) {
      USER_DATA.remove();
      FILTER_DATA.remove();
      PROFILE_DATA.remove(); // Remove on logout or token expiry
      await localforage.removeItem("userData");
      return null;
    }
    if (loginData === process.env.REACT_APP_CHECK_PWD_EXPIRATION_AUTHCODE)
      return loginData; // Preliminary JWT token
    const data = jwtDecode(loginData);
    const currentTime = Math.floor(Date.now() / 1000);
    return data.exp && data.exp > currentTime ? loginData : null;
  },
  set: (token: string) => sessionStorage.setItem(DataCacheKey.TOKEN_KEY, token),
  remove: () => sessionStorage.removeItem(DataCacheKey.TOKEN_KEY),
};

export const USER_DATA = {
  get: async () => {
    const value = await localforage.getItem<CustomerDataEntry[]>(
      DataCacheKey.USER_OVERALL_DATA_KEY
    );
    return value || [];
  },
  set: (value: CustomerDataEntry[]) =>
    localforage.setItem<CustomerDataEntry[]>(
      DataCacheKey.USER_OVERALL_DATA_KEY,
      value
    ),
  remove: () => localforage.removeItem(DataCacheKey.USER_OVERALL_DATA_KEY),
};

export const PROFILE_DATA = {
  get: async () => {
    const data = await localforage.getItem("brad-profile-data");
    return data ? JSON.parse(data as string) : null;
  },
  set: (data: any) => {
    localforage.setItem("brad-profile-data", JSON.stringify(data));
  },
  remove: () => localforage.removeItem("brad-profile-data"),
};

export const FILTER_DATA = {
  get: async (): Promise<FilterData> => {
    const value = await localforage.getItem<FilterData>(
      DataCacheKey.FILTER_DATA_KEY
    );
    return (
      value || {
        selectedDateIndex: -1,
        customerIndex: 0,
        siteIndex: [],
        wasteTypeIndex: [],
        startDate: "",
        endDate: "",
      }
    );
  },
  set: async (key: number, value: number | number[] | string | Date[]) => {
    const prevItem = (await localforage.getItem<FilterData>(
      DataCacheKey.FILTER_DATA_KEY
    )) || {
      selectedDateIndex: -1,
      customerIndex: 0,
      siteIndex: [],
      wasteTypeIndex: [],
      startDate: "",
      endDate: "",
    };
    switch (key) {
      case 0:
        prevItem.customerIndex = value as number;
        prevItem.siteIndex = [];
        prevItem.wasteTypeIndex = [];
        break;
      case 1:
        prevItem.siteIndex = value as number[];
        break;
      case 2:
        prevItem.wasteTypeIndex = value as number[];
        break;
      case 3:
        prevItem.startDate = (value as Date[])[0].toString();
        prevItem.endDate = (value as Date[])[1].toString();
        break;
      case 4:
        prevItem.selectedDateIndex = value as number;
    }
    localforage.setItem<FilterData>(DataCacheKey.FILTER_DATA_KEY, prevItem);
  },
  remove: () => localforage.removeItem(DataCacheKey.FILTER_DATA_KEY),
};
